/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */

import { z } from 'zod';
import type { IAPI } from '../apiResponse';
import { createApiResponseSchema } from '../apiResponse';

export const idAckSchema = z.object({ id: z.number() });
export type IIdAck = z.infer<typeof idAckSchema>;

export const idAckResponseSchema = createApiResponseSchema(idAckSchema) as import('zod').ZodSchema<
  IAPI<IIdAck>
>;
export type IIdAckResponse = IAPI<IIdAck>;

export const uploadPathSchema = z.object({ path: z.string() });
export type IUploadPath = z.infer<typeof uploadPathSchema>;

export const uploadPathResponseSchema = createApiResponseSchema(
  uploadPathSchema,
) as import('zod').ZodSchema<IAPI<IUploadPath>>;
export type IUploadPathResponse = IAPI<IUploadPath>;
